import { useBoolean } from '@dreryk/react-common';

import { CustomPatientGroupsCreateModal } from './CustomPatientGroupsCreateModal';

type CustomPatientGroupsCreateModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type CustomPatientGroupsCreateModalOpenerProps = {
   children: (renderProps: CustomPatientGroupsCreateModalOpenerRenderProps) => JSX.Element;
};

export const CustomPatientGroupsCreateModalOpener = (props: CustomPatientGroupsCreateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <CustomPatientGroupsCreateModal onClose={closeModal} /> : null}
      </>
   );
};
